// Initialize the loader end flag to false
if (typeof window.__loaderEndEmitted === 'undefined') {
  window.__loaderEndEmitted = false;
}

// Calculate animation timing values explicitly
const LOADING_DURATION_1 = 1000;
const LOADING_DELAY_1 = 1000;
const LOADING_DURATION_2 = 2000;
const LOADING_DELAY_2 = LOADING_DELAY_1 + LOADING_DURATION_1; // 2000
const LOADING_REPETITIONS_2 = 2;
const LOADING_DURATION_3 = 2500;
const LOADING_DELAY_3 = LOADING_DELAY_2 + (LOADING_DURATION_2 * LOADING_REPETITIONS_2); // 2000 + (2000 * 2) = 6000
const LOADING_DURATION_4 = 300;
const LOADING_DELAY_4 = LOADING_DELAY_3 + LOADING_DURATION_3 - 2000; // 6000 + 2500 - 2000 = 6500
const LOADING_TOTAL_DURATION = LOADING_DELAY_3 + LOADING_DURATION_3 - 1000; // 6000 + 2500 - 1000 = 7500

// Animation timing object for Alpine component (with getters for dynamic access)
const animationTiming = {
  LOADING_DURATION_1,
  LOADING_DELAY_1,
  LOADING_DURATION_2,
  get LOADING_DELAY_2() { return LOADING_DELAY_2 },
  LOADING_REPETITIONS_2,
  LOADING_DURATION_3,
  get LOADING_DELAY_3() { return LOADING_DELAY_3 },
  LOADING_DURATION_4,
  get LOADING_DELAY_4() { return LOADING_DELAY_4 },
  get LOADING_TOTAL_DURATION() { return LOADING_TOTAL_DURATION }
};

// Start the loader timer immediately when the script loads
// This ensures the timer starts even if Alpine hasn't initialized the component yet
setTimeout(() => {
  window.__loaderEndEmitted = true;
  const loaderEndTime = new CustomEvent('loader:end');
  window.dispatchEvent(loaderEndTime);
}, LOADING_TOTAL_DURATION);

document.addEventListener('alpine:init', () => {
  Alpine.data('loader', () => ({
    animationTiming: animationTiming,

    init() {
      Object.entries(this.animationTiming).forEach(([key, value]) => {
        document.documentElement.style.setProperty(`--${key}`, `${value}${key.includes('LOADING_DURATION') || key.includes('LOADING_DELAY') ? 'ms' : ''}`);
      });
    }
  }))
});